import React, { FC, ReactElement, useState, useEffect } from "react";

import { DeleteOutline } from "@mui/icons-material";
import ShareIcon from "@mui/icons-material/Share";
import InfoIcon from "@mui/icons-material/Info";
import DoneIcon from "@mui/icons-material/Done";
import {
  Checkbox,
  Divider,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Tooltip,
  Popover,
  Grid,
  TextField,
  List,
  Box,
  Typography,
} from "@mui/material";

import fileTypes from "../../data/fileType";
import apiCall from "../../utils/apiCall";
import {
  DATABASE,
  EXCEL,
  IMAGE,
  NEO4J,
  PDF,
  YOUTUBE,
} from "../../data/constants";

import { useAppDispatch, useAppSelector } from "../../hooks/reduxhook";
import { addFiles, getType } from "../../redux/slices/typeSlice";
import {
  addCypher,
  getconversationid,
  getSelectedIndexes,
  updateIndexes,
} from "../../redux/slices/conversationSlice";
import { loadingforindexes } from "../../redux/slices/loadingSlice";
import { useMsal } from "@azure/msal-react";
import { GET_WITH_WHOM_DOCS_IS_SHARED, SHARE_DOCS_WITH } from "../../endpoint";
import { addError, addSuccessMessage } from "../../redux/slices/errorSlice";
import SharedUser from "../SharedUser";
import { getSendingFullDocument } from "../../redux/slices/userSlice";
import ConfirmDeleteModal from "../ConfirmDelete";
import { SHARE_IMAGES_WITH } from "../../endpoint";
import { GET_WITH_WHOM_IMAGES_IS_SHARED } from "../../endpoint";
import { GET_USER_EMAILS } from "../../endpoint";
import { getModelDetails } from "../../redux/slices/modelSlice";

interface i_listOption {
  checkboxcondition: boolean;
  onClick: (type: string) => void;
  type: string;
  fileType: string;
  data?: any;
  title?: string;
}

const ListOption: FC<i_listOption> = ({
  checkboxcondition,
  onClick,
  type,
  fileType,
  data,
  title,
}): ReactElement => {
  const chatType = useAppSelector(getType);
  const selectedIndexes = useAppSelector(getSelectedIndexes);
  const current_conversation_id = useAppSelector(getconversationid);
  const full_doc = useAppSelector(getSendingFullDocument);
  const models = useAppSelector(getModelDetails);

  const dispatch = useAppDispatch();
  const { accounts } = useMsal();
  const account = accounts[0];

  const [anchorEl, setAnchorEl] = React.useState<
    (EventTarget & SVGSVGElement) | null
  >(null);

  const [sharedEmail, setSharedEmail] = React.useState<string>("");
  const [emails, setEmails] = React.useState<string[]>([]);
  const [userEmails, setUserEmails] = React.useState<{ user_email: string }[]>(
    [],
  );
  const [showSharedUsers, setShowSharedUsers] = React.useState<boolean>(false);
  const [filteredEmails, setFilteredEmails] = React.useState<string[]>([]);
  const [showSuggestions, setShowSuggestions] = React.useState<boolean>(false);
  const [showConfirmDelete, setShowConfirmDelete] = useState(false);
  const handleClick = (event: React.MouseEvent<SVGSVGElement, MouseEvent>) => {
    setAnchorEl(event.currentTarget);
  };

  useEffect(() => {
    const fetchData = () => {
      apiCall("GET", GET_USER_EMAILS)
        .then((res) => {
          setUserEmails(res.result);
        })
        .catch((err) => {
          console.log(err);
        });
    };
    fetchData();
  }, []);
  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  const includeIndexes = (e: any, index: string) => {
    e?.stopPropagation();
    if (chatType.type === PDF) {
      if (!full_doc) {
        if (e.target.checked) {
          dispatch(updateIndexes([...selectedIndexes, index]));
        } else {
          dispatch(updateIndexes(selectedIndexes.filter((e) => e !== index)));
        }
      } else {
        if (e.target.checked) {
          dispatch(updateIndexes([index]));
        } else {
          dispatch(updateIndexes([]));
        }
      }
    } else if (chatType.type === IMAGE || chatType.type === YOUTUBE) {
      if (e.target.checked) {
        dispatch(updateIndexes([...selectedIndexes, index]));
      } else {
        dispatch(updateIndexes(selectedIndexes.filter((e) => e !== index)));
      }
    } else {
      if (e.target.checked) {
        dispatch(updateIndexes([index]));
      } else {
        dispatch(updateIndexes([]));
      }
    }
    if (chatType.type === NEO4J && e.target.checked) {
      dispatch(
        addCypher({
          url: data?.creds?.url,
          username: data?.creds?.username,
          password: data?.creds?.password,
        }),
      );
      apiCall("POST", chatType.chaturl, {
        user_email: account.username,
        db_name: data?.db_name,
        query: "mention the different node types given in the database",
        temp: 0,
        model: models?.models?.chat[0]?.model_name,
        conv_id: current_conversation_id,
        db_call: true,
      });
    }
  };

  const deleteIndex = (index: string) => {
    setShowConfirmDelete(false);
    dispatch(loadingforindexes(true));
    apiCall("POST", chatType.deleteurl, {
      chunk_name: index,
      image_name: index,
      file_name: index,
      db_name: index,
      video_name: index,
      user_email: account?.username,
    })
      .then((res) => {
        dispatch(addFiles(res.result));
      })
      .catch((err) => {
        dispatch(addError("Failed to delete a file.Please try again."));
      })
      .finally(() => {
        dispatch(loadingforindexes(false));
      });
  };

  const shareDocument = () => {
    // apiCall("POST", SHARE_DOCS_WITH, {
    //   shared_user_email: sharedEmail,
    //   index_name: type,
    // })
    //   .then((res) => {
    //     if (res.result === "user not found") {
    //       dispatch(addError("User not found"));
    //     } else {
    //       dispatch(addSuccessMessage("Successfully added user"));
    //       handleClose();
    //     }
    //   })
    //   .catch((err) => {
    //     dispatch(
    //       addError("Failed to share a file with the user.Please try again")
    //     );
    //   });

    if (chatType.type === PDF) {
      apiCall("POST", SHARE_DOCS_WITH, {
        shared_user_email: sharedEmail,
        index_name: type,
      })
        .then((res) => {
          if (res.result === "user not found") {
            dispatch(addError("User not found"));
          } else {
            dispatch(addSuccessMessage("Successfully shared the Doc"));
            handleClose();
          }
        })
        .catch((err) => {
          dispatch(addError("Something went wrong while adding user"));
          console.error(err);
        });
    } else if (chatType.type === IMAGE) {
      apiCall("POST", SHARE_IMAGES_WITH, {
        shared_user_email: sharedEmail,
        image_name: type,
      })
        .then((res) => {
          if (res.result === "user not found") {
            dispatch(addError("User not found"));
          } else {
            dispatch(addSuccessMessage("Successfully shared the image"));
            handleClose();
          }
        })
        .catch((err) => {
          dispatch(addError("Something went wrong while adding user"));
          console.error(err);
        });
    }
  };

  const getSharedUsers = () => {
    // apiCall("POST", GET_WITH_WHOM_DOCS_IS_SHARED, {
    //   index_name: type,
    // })
    //   .then((res) => {
    //     setEmails(res.result);
    //     setShowSharedUsers(true);
    //   })
    //   .catch((err) => {
    //     dispatch(
    //       addError("Failed to load the list of shared users.Please try again")
    //     );
    //   });
    if (chatType.type === PDF) {
      apiCall("POST", GET_WITH_WHOM_DOCS_IS_SHARED, {
        index_name: type,
      })
        .then((res) => {
          setEmails(res.result);
          setShowSharedUsers(true);
        })
        .catch((err) => {
          dispatch(addError("Something went wrong while getting shared users"));
          console.error(err);
        })
        .finally(() => {
          //setShowSharedUsers(false);
          //setEmails([]);
        });
    } else if (chatType.type === IMAGE) {
      apiCall("POST", GET_WITH_WHOM_IMAGES_IS_SHARED, {
        image_name: type,
      })
        .then((res) => {
          setEmails(res.result);
          setShowSharedUsers(true);
        })
        .catch((err) => {
          dispatch(addError("Something went wrong while getting shared users"));
          console.error(err);
        })
        .finally(() => {
          // setShowSharedUsers(false);
          //setEmails([]);
        });
    }
  };

  const handleEmailChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const inputValue = e.target.value;
    setSharedEmail(inputValue);
    const suggestion = userEmails
      .map((item) => item?.user_email)
      .filter((email) =>
        email.toLocaleLowerCase().includes(inputValue.toLocaleLowerCase()),
      );
    setFilteredEmails(suggestion);
    setShowSuggestions(!!inputValue);
  };

  const handleSelectSuggestion = (email: string) => {
    setSharedEmail(email);
    setShowSuggestions(false);
  };

  return (
    <ListItem disablePadding sx={{ display: "block" }}>
      <Tooltip
        title={
          fileType === "excel" || fileType === "sql" || fileType === "neo4j"
            ? null
            : title +
              (type.split("---")[0]?.length > 13
                ? " " + type.split("---")[0]
                : "")
        }
      >
        <ListItemButton
          sx={{
            minHeight: 48,
            justifyContent: "initial",
          }}
        >
          <Checkbox
            id="filechecked"
            defaultChecked
            color="success"
            sx={{
              m: 0,
              p: 0,
              mr: 0.5,
            }}
            size="small"
            checked={checkboxcondition}
            onChange={(e) => includeIndexes(e, type)}
            aria-label="checkbox"
          />
          <ListItemIcon
            sx={{
              minWidth: 0,
              mr: 0.5,
              justifyContent: "center",
            }}
            onClick={() => onClick(type)}
          >
            <img src={fileTypes[`${fileType}`]} width="20" />
          </ListItemIcon>
          {type.split("---")[0]?.length > 13 ? (
            <ListItemText
              id="clickonimage"
              primary={type.split("---")[0].substring(0, 8) + "..."}
              sx={{
                opacity: 1,
              }}
              onClick={() => onClick(type)}
              aria-label={type.split("---")[0]}
            />
          ) : (
            <ListItemText
              id="clickontext"
              primary={type.split("---")[0]}
              sx={{
                opacity: 1,
              }}
              onClick={() => onClick(type)}
              aria-label={type.split("---")[0]}
            />
          )}
          {!(chatType.type === EXCEL && type === "finance") &&
            !(chatType.type === DATABASE && type === "sales") && (
              <Tooltip title="Delete">
                <DeleteOutline
                  id="deletefile"
                  color="primary"
                  fontSize="small"
                  aria-label="delete icon"
                  onClick={() => setShowConfirmDelete(!showConfirmDelete)}
                />
              </Tooltip>
            )}
          {(chatType.type === PDF || chatType.type === IMAGE) && (
            <>
              <Tooltip title="Share">
                <ShareIcon
                  id="shareicon"
                  color="primary"
                  fontSize="small"
                  onClick={(e) => handleClick(e)}
                  aria-label="share icon"
                />
              </Tooltip>
              <Tooltip title="Shared with">
                <InfoIcon
                  id="infoicon"
                  color="primary"
                  fontSize="small"
                  aria-label="info icon"
                  onClick={getSharedUsers}
                />
              </Tooltip>
            </>
          )}
        </ListItemButton>
      </Tooltip>
      <Divider />
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        sx={{
          ".MuiPopover-paper": {
            width: "300px",
          },
        }}
      >
        <Grid container alignItems="center">
          <TextField
            value={sharedEmail}
            onChange={handleEmailChange}
            label="Enter email"
            // sx={{ mt: 2 }}
            variant="standard"
            sx={{
              m: 0.5,
              flex: 1,
            }}
            size="small"
            onFocus={() => setShowSuggestions(true)}
          />
          <DoneIcon
            color="success"
            fontSize="small"
            onClick={() => shareDocument()}
            sx={{
              mr: 1,
              cursor: "pointer",
            }}
          />
        </Grid>
        {showSuggestions && filteredEmails.length > 0 && (
          <List
            sx={{
              maxHeight: filteredEmails.length > 4 ? "160px" : "auto",
              overflow: filteredEmails.length > 4 ? "auto" : "visible",
              borderTop: "1px solid #ccc",
              padding: 0,
            }}
          >
            {filteredEmails.map((email, index) => (
              <ListItem
                key={index}
                sx={{
                  "&:hover": { background: "#f0f0f0" },
                  cursor: "pointer",
                }}
                onClick={() => handleSelectSuggestion(email)}
              >
                <ListItemText
                  primary={email}
                  sx={{
                    padding: "4px",
                  }}
                  primaryTypographyProps={{
                    fontSize: "0.875rem",
                  }}
                />
              </ListItem>
            ))}
          </List>
        )}
        {showSuggestions && filteredEmails.length === 0 && (
          <Box sx={{ padding: "8px" }}>
            <Typography variant="body2">No matches found</Typography>
          </Box>
        )}
      </Popover>
      <SharedUser
        open={showSharedUsers}
        setOpen={setShowSharedUsers}
        data={emails}
      />
      <ConfirmDeleteModal
        show={showConfirmDelete}
        cancel={() => setShowConfirmDelete(false)}
        confirm={() => deleteIndex(type)}
      />
    </ListItem>
  );
};

export default ListOption;
